<template>
  <div :class="hasWebp ? 'raas' : 'raas noWebp'">
    <div class="raas_box raas_main">
      <div class="raas_inner">
        <div class="raas_main_banner">
          <div class="raas_main_blt">
            <div class="rs_title">品牌全球商业增长BaaS方案</div>
            <div class="rs_sub">基于复杂商业科学的战略地图</div>
          </div>
          <div class="raas_main_brt">
            <img v-if="hasWebp" src="../../static/imgs/baas_main_1.webp" alt="">
            <img v-else src="../../static/imgs/baas_main_1.png" alt="">
          </div>
        </div>
        <A-Button text='进一步了解' class="rs_button" @onclick="openOrder"></A-Button>
        <!-- <A-Button text='免费获得行金理票报告' class="rs_button" style="margin-right: 40px;" @onclick="openOrder"></A-Button> -->
      </div>
    </div>
    <div class="raas_box raas_chance raasc1">
      <div class="raas_inner">
        <div class="rs_title wt">战略升维，获悉商业情报</div>
        <div class="rs_sub wt">没有方向，所有努力都是「熵增」</div>
        <!-- <div class="rs_res">以当地消费者认知为根本，利用数字化手段提供全面的，实时的本地化洞察</div> -->
        <em class="rs_title_line"></em>
      </div>
      <div class="raas_chance_bottom rscb_1">
        <div class="raas_chance_item">
          <div class="raas_chance_lt">
            <img src="../../static/imgs/baas_chance_1.svg" alt="">
          </div>
          <div class="raas_chance_rt">
            <div class="rs_chance_title">天生国际范</div>
            <div class="rs_chance_res">天眼洞悉全球市场</div>
            <div class="rs_chance_res">天然搭建国际市场框架</div>
            <div class="rs_chance_res">G-local模式下的国际化-本土化</div>
          </div>
        </div>
        <div class="raas_chance_item reverse">
          <div class="raas_chance_lt">
            <img src="../../static/imgs/baas_chance_2.svg" alt="">
          </div>
          <div class="raas_chance_rt">
            <div class="rs_chance_title">快人半步，抢滩登陆</div>
            <div class="rs_chance_res">大数据本地化洞察及早识别趋势</div>
            <div class="rs_chance_res">瞄准蓝海市场，精准出击</div>
            <div class="rs_chance_res">知己知彼，弯道超车的关键路径</div>
          </div>
        </div>
        <div class="raas_chance_item">
          <div class="raas_chance_lt">
            <img src="../../static/imgs/baas_chance_3.svg" alt="">
          </div>
          <div class="raas_chance_rt">
            <div class="rs_chance_title">与市场合谋</div>
            <div class="rs_chance_res">本地化用户运营</div>
            <div class="rs_chance_res">远程本地化洞察</div>
            <div class="rs_chance_res">基于用户思维的C2B2M的增长秘籍</div>
          </div>
        </div>
      </div>
    </div>
    <div class="raas_box raas_chance raas_channel">
      <div class="raas_inner">
        <div class="rs_title wt">战略解码，深挖精细潜能</div>
        <div class="rs_sub wt">“眼高手低”，战略才能有效落地</div>
        <!-- <div class="rs_res">通过数据+经验进行渠道评估，按业务分国家分层级设计渠道扩展线路图</div> -->
        <em class="rs_title_line"></em>
      </div>
      <div class="raas_chance_bottom">
        <div class="raas_chance_item reverse">
          <div class="raas_chance_lt">
            <img src="../../static/imgs/baas_channel_1.png" alt="" />
          </div>
          <div class="raas_chance_rt">
            <div class="rs_chance_title">精益迭代ERP</div>
            <div class="rs_chance_res">揭秘轻资产“0”库存的运营模式</div>
            <div class="rs_chance_res">工程迭代验证趋势涌现的确定性</div>
            <div class="rs_chance_res">战役地图，数字沙盘降低增长风险</div>
          </div>
        </div>
        <div class="raas_chance_item">
          <div class="raas_chance_lt">
            <img src="../../static/imgs/baas_channel_2.svg" alt="" />
          </div>
          <div class="raas_chance_rt">
            <div class="rs_chance_title">精细化卓越运营</div>
            <div class="rs_chance_res">差异化营销方式拒绝价格内卷</div>
            <div class="rs_chance_res">全球数字化供应链网络最优化成本</div>
            <div class="rs_chance_res">精细化用户运营突破业务增长</div>
          </div>
        </div>
        <div class="raas_chance_item reverse">
          <div class="raas_chance_lt">
            <img src="../../static/imgs/baas_channel_3.svg" alt="" />
          </div>
          <div class="raas_chance_rt">
            <div class="rs_chance_title">通关秘籍</div>
            <div class="rs_chance_res">品牌增长参谋，数据积累势能向上</div>
            <div class="rs_chance_res">智能向导专家团大数据辅助决策</div>
            <div class="rs_chance_res">战略罗盘掌控增长速度与方向</div>
          </div>
        </div>
      </div>
    </div>
    <div class="raas_box raas_chance raas_product">
      <div class="raas_inner">
        <div class="rs_title wt">战略扩张，渠道增量增效</div>
        <div class="rs_sub wt">找到杠杆，实现企业高速拓市</div>
        <!-- <div class="rs_res">坚持以客户之声为出发点，提供以大数据为基础，以消费者为中心，以市场为导向的产品策略</div> -->
        <em class="rs_title_line"></em>
      </div>
      <div class="raas_chance_bottom">
        <div class="raas_chance_item">
          <div class="raas_chance_lt">
            <img src="../../static/imgs/baas_product_1.svg" alt="">
          </div>
          <div class="raas_chance_rt">
            <div class="rs_chance_title">拓市-全渠道蓝图</div>
            <div class="rs_chance_res">百亿级销售额验证商业国际化地图</div>
            <div class="rs_chance_res">大数据AI组合拳扩展跨境流量地图</div>
            <div class="rs_chance_res">为好产品匹配好渠道</div>
          </div>
        </div>
        <div class="raas_chance_item reverse">
          <div class="raas_chance_lt">
            <img src="../../static/imgs/baas_product_2.svg" alt="">
          </div>
          <div class="raas_chance_rt">
            <div class="rs_chance_title">破壁-从1到N</div>
            <div class="rs_chance_res">重构线上线下流通链路，全渠道打通</div>
            <div class="rs_chance_res">国际化线上分销服务</div>
            <div class="rs_chance_res">国际化线下分销服务</div>
          </div>
        </div>
        <div class="raas_chance_item">
          <div class="raas_chance_lt">
            <img src="../../static/imgs/baas_product_3.svg" alt="">
          </div>
          <div class="raas_chance_rt">
            <div class="rs_chance_title">国际化线下分销服务</div>
            <div class="rs_chance_res">产品、定位、渠道、体验全方位蝶变</div>
            <div class="rs_chance_res">从渠道品牌走向产品品牌</div>
            <div class="rs_chance_res">全球全渠道品牌管理</div>
          </div>
        </div>
      </div>
    </div>
    <div class="raas_box raas_chance raas_way">
      <div class="raas_inner">
        <div class="rs_sub wt">Volatility, Uncertainty, Complexity, Ambiguity</div>
        <div class="rs_title wt">暗知识的时代已经来临</div>
        <em class="rs_title_line"></em>
      </div>
      <div class="raas_why_bottom">
        <div class="raas_why_item">
          <img src="../../static/imgs/baas_way_1.svg" alt="">
          <div class="rs_why_title">基于全球电商数据资源的<br>消费者认知和洞察</div>
          <div class="rs_why_title_en">Date resource</div>
          <em class="rs_why_title_line"></em>
          <div class="rs_why_res">ANTDIY拥有全球最大的电商数据，洞悉海外市场的现状和发展趋势，以及消费者的痛点和需求；从产品本土化，营销本土化到渠道本土化决策都有据可循</div>
        </div>
        <div class="raas_why_item">
          <img src="../../static/imgs/baas_way_2.svg" alt="">
          <div class="rs_why_title">工程化测试推动<br>认知选代的方法论</div>
          <div class="rs_why_title_en">Methodology</div>
          <em class="rs_why_title_line"></em>
          <div class="rs_why_res">C2B的工程化测试，进行低成本高效的持续认知选代，加速数据沉淀；从用户运营，市场营销到产品创新，打通数据壁垒， 让测试数据“为我所用” </div>
        </div>
        <div class="raas_why_item">
          <img src="../../static/imgs/baas_way_3.svg" alt="">
          <div class="rs_why_title">全球销售网络的<br>智能ERP</div>
          <div class="rs_why_title_en">Technology</div>
          <em class="rs_why_title_line"></em>
          <div class="rs_why_res">在ANTDIY一个平台管理多个线上渠道以及线下渠道的直销和分销；从产品、营销、客户、履约、仓配、物流等全方位实行电子商务自动化管理</div>
        </div>
      </div>
    </div>
    <div class="raas_box raas_break">
      <div class="raas_inner">
        <div class="rs_title">在品牌出海在进入目标市场初期，<div></div>ANTDIY协助品牌规划基础能力建设，快速打破瓶颈</div>
        <em class="rs_title_line"></em>
        <div class="rs_break_bottom">
          <div class="rs_break_item">
            <img src="../../static/imgs/baas_break_1.svg" alt="">
            <div class="rs_break_rt">
              <div class="rs_break_title">市场准入</div>
              <div class="rs_break_res">300+跨境渠道，国际化团队助力品牌出海精准入局</div>
            </div>
          </div>
          <div class="rs_break_item">
            <img src="../../static/imgs/baas_break_2.svg" alt="">
            <div class="rs_break_rt">
              <div class="rs_break_title">混合云建站</div>
              <div class="rs_break_res">当地化素材+视角建立品牌官网+测试网站，双轮驱动</div>
            </div>
          </div>
          <div class="rs_break_item">
            <img src="../../static/imgs/baas_break_3.svg" alt="">
            <div class="rs_break_rt">
              <div class="rs_break_title">智能ERP</div>
              <div class="rs_break_res">300+跨境渠道，国际化团队助力品牌出海精准入局</div>
            </div>
          </div>
          <div class="rs_break_item">
            <img src="../../static/imgs/baas_break_4.svg" alt="">
            <div class="rs_break_rt">
              <div class="rs_break_title">多渠道精准引流</div>
              <div class="rs_break_res">全渠道流量地图，专业市场营销团队智能增长</div>
            </div>
          </div>
          <div class="rs_break_item">
            <img src="../../static/imgs/baas_break_5.svg" alt="">
            <div class="rs_break_rt">
              <div class="rs_break_title">可视化数据洞察</div>
              <div class="rs_break_res">商业智能罗盘，生意可持续增长</div>
            </div>
          </div>
          <div class="rs_break_item">
            <img src="../../static/imgs/baas_break_6.svg" alt="">
            <div class="rs_break_rt">
              <div class="rs_break_title">全球物流仓储</div>
              <div class="rs_break_res">智能物流仓储，海外履约无忧模式</div>
            </div>
          </div>
          <div class="rs_break_item">
            <img src="../../static/imgs/baas_break_7.svg" alt="">
            <div class="rs_break_rt">
              <div class="rs_break_title">专属运营陪伴式服务 </div>
              <div class="rs_break_res">全程多对一专家陪伴式咨询服务</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="raas_box raas_case">
      <div class="raas_inner">
        <div class="rs_title">ANTDIY成功合作的跨境零售卖家</div>
        <em class="rs_title_line"></em>
        <div class="rs_bar">
          <div :class="tabId === index ? 'rs_tab rs_tab_active' : 'rs_tab'" v-for="(item, index) in tabData" :key="index" @click="tabId = index"  @mouseenter="tabId = index">{{item.title}}</div>
        </div>
        <div :class="tabId === index ? 'rs_case_bottom rs_case_bottom_active':'rs_case_bottom'" v-for="(item, index) in tabData" :key="index">
          <div class="rsc_title"><img class="rsc_icon" :src="item.icon" alt="">{{item.user}}</div>
          <div class="rsc_res1">{{item.des1}}</div>
          <img class="rsc_img" :src="item.img" alt="">
          <div class="rsc_res2">{{item.des2}}</div>
        </div>
      </div>
    </div> -->
    <FooterCN></FooterCN>
    <Sidebanner :openOrder="isOpenOrder"></Sidebanner>
  </div>
</template>

<script>
import FooterCN from './common/footerCNNew.vue';
import Sidebanner from './common/sidebanner.vue'
export default {
  name:'solution-baas',
  components:{
    FooterCN,
    Sidebanner
  },
  props: ['hasWebp'],
  data(){
    return{
      tabData: [
        {
          title: "01、淘宝卖家转型",
          icon: "../../static/imgs/raas_case_icon_1.svg",
          user: "李先生-淘宝卖家：",
          des1: "“ANTDIY的业务经理联系我，当时就很感兴趣，疫情导致国内市场一蹶不振，海外国家的消费品市场已经全面复苏了，所以跨境电商的机会回来了。",
          img: "../../static/imgs/raas_case_1.png",
          mimg: "../../static/imgs/raas_case_m1.png",
          des2: "ANTDIY帮助我调研市场，推荐选品，完成独立站搭建，又快又省事，遇到问题就能找到专家解决。师傅领进门，修行靠个人，有ANTDIY这么负责的伙伴，我相信年底前能冲刺1000w美金GMV！”",
        },
        {
          title: "02、线下卖家转型",
          icon: "../../static/imgs/raas_case_icon_2.svg",
          user: "张老板-义乌小商品经销商：",
          des1: "“从业10年一直做黑人兄弟生意，锅碗瓢盆日用品，曾经生意很好做。\n2020年疫情以来，进货的朋友明显变少了，咱就研究自己卖，学习了几个大平台的销售办法，英文看不懂，政策规则太难太复杂了。",
          img: "../../static/imgs/raas_case_2.png",
          mimg: "../../static/imgs/raas_case_m2.png",
          des2: "去年ANTDIY找到我，帮我搭建了网站，教会我投广告，现在直接把商品零售给非洲朋友，上个月卖了20w美金，比以前出货量还大！正在和ANTDIY合作多开几个网站，多卖几个类目！”",
        },
        {
          title: "03、亚马逊卖家转型",
          icon: "../../static/imgs/raas_case_icon_3.svg",
          user: "jason-亚马逊卖家：",
          des1: "“2015年就开始做跨境电商了，2018年巅峰时期一个季度2000w美金营业额，结果遇上疫情一蹶不振，物流价格暴涨，亚马逊强制要求入海外仓，外汇监管，封店...凭本事赚的钱，市场环境下又亏回去了。",
          img: "../../static/imgs/raas_case_3.png",
          mimg: "../../static/imgs/raas_case_m3.png",
          des2: "去年接触ANTDIY，确实独立站还有机会，如今合作一年，整体效益已经和原有业务持平了，继续跟着政策方向，走出去做自己的生意！”",
        },
        {
          title: "04、品牌出海",
          icon: "../../static/imgs/raas_case_icon_4.svg",
          user: "林总-中国知名茶叶品牌创始人：",
          des1: "“线下卖了20年，淘宝卖了10年，茶制品行业我的品牌已经全国前三了！合伙人带ANTDIY的伙伴来公司喝茶，聊到品牌出海，正合我意。从市场调研，数据分析，网站搭建，商品运营，营销推广，支付结汇，几乎所有事都是ANTDIY团队在做，让我又省钱又省心。",
          img: "../../static/imgs/raas_case_4.png",
          mimg: "../../static/imgs/raas_case_m4.png",
          des2: "现在我们品牌已经在东欧和东亚卖火了，正在和ANTDIY合作开发北美和英国市场，我们也和立顿掰掰手腕，分一块全球茶制品的市场份额！“",
        },
      ],
      tabId: 0,
      mbFlag: false,
      isOpenOrder: false,
    }
  },
  methods:{
    consult(){
      if (window.fcWidget.isLoaded()) {
        window.fcWidget.open()
      }
    },
    openOrder() {
      this.isOpenOrder = true;
      setTimeout(() => {
        this.isOpenOrder = false;
      }, 500);
    }
  },
  created(){
    document.title = '全球云店——想法即商业，开店即开张';;;
    if (window.innerWidth < 767) {
      this.mbFlag = true;
    }
  }
}
</script>
<style scoped>
  .raas {
    width: 100%;
  }
  .raas_box {
    width: 100%;
  }
  .raas_inner {
    width: 1200px;
    margin: 0 auto;
    padding: 80px 0;
  }
  .rs_title {
    font-family: SourceHanSansCN-Bold !important;
    font-size: 54px;
    color: #222536;
    letter-spacing: 0.75px;
    line-height: 54px;
    font-weight: 700;
  }
  .rs_sub {
    font-family: SourceHanSansCN-Bold !important;
    font-size: 40px;
    color: #222536;
    letter-spacing: 0.56px;
    line-height: 46px;
    font-weight: 700;
    margin-top: 23px;
  }
  .rs_res {
    font-family: SourceHanSansCN-Regular !important;
    font-size: 28px;
    color: #DADADA;
    font-weight: 400;
  }
  .rs_button {
    padding: 0 68px;
    height: 58px;
    border-radius: 8px;
    font-family: SourceHanSansCN-Medium !important;
    font-size: 24px;
    line-height: 56px;
    color: #FFFFFF;
    font-weight: 500;
    /* background: #FB5421; */
    box-shadow: 0px 6px 16px 0px rgba(251,84,33,0.33);
  }
  .rs_button_tran {
    background: rgba(251,84,33,0.2);
    border: 1.5px solid rgba(251,84,33,0.85);
    box-shadow: 0px 6px 16px 0px rgba(255,144,85,0.26);
    border-radius: 8px;
    line-height: 53px;
    backdrop-filter: blur(10px);
  }
  .rs_button_tran:hover {
    background: rgba(251,84,33,0.30);
    border: 1.5px solid rgba(251,84,33,0.85);
    box-shadow: 0px 6px 16px 0px rgba(255,144,85,0.26);
    border-radius: 8px;
  }
  .rs_title_line {
    display: inline-block;
    width: 60px;
    height: 8px;
    background: #FC5421;
    border-radius: 6px;
    margin-top: 34px;
  }
  .wt {
    color: #FFFFFF;
  }
  .reverse {
    flex-direction: row-reverse;
  }


  .raas_main {
    background: url("../../static/imgs/baas_bg_main.webp") center/cover,
    #02021D;
  }
  .noWebp .raas_main {
    background: url("../../static/imgs/baas_bg_main.png") center/cover,
    #02021D;
  }
  .raas_main .raas_inner {
    /* padding: 177px 0 182px; */
    padding: 220px 0;
    position: relative;
  }
  .raas_main_banner {
    display: flex;
    justify-content: space-between;
    /* margin-bottom: -61px; */
  }
  .raas_main_blt {
    position: relative;
  }
  .raas_main .rs_title {
    font-size: 40px;
    color: #FFFFFF;
    letter-spacing: 5px;
    line-height: 40px;
    margin-top: 40px;
  }
  .raas_main .rs_sub {
    font-size: 24px;
    line-height: 24px;
    letter-spacing: 2.83px;
    font-weight: 500;
    color:  #D7DCE9;
    margin-top: 51px;
  }
  .raas_main_brt {
    margin-left: 34px;
  }
  .raas_main_brt img {
    width: 582px;
    height: 369px;
  }
  .raas_main .rs_button {
    position: absolute;
    bottom: 250px;
  }

  .raas_chance {
    display: flex;
    flex-direction: column;
    margin-top: -1px;
  }
  .raas_chance .raas_inner {
    background: url("../../static/imgs/baas_bg_chance.png") center/cover;
    width: 100%;
    text-align: center;
    padding: 132px 0 130px;
    /* margin-top: -1px; */
  }
  .raasc1 .raas_inner {
    padding: 95px 0 93px;
  }
  .raas_chance .rs_sub {
    margin-top: 23px;
  }
  .raas_chance .rs_title {
    /* margin-top: 30px; */
  }
  .raas_chance .rs_res {
    margin-top: 40px;
  }
  .raas_chance .rs_title_line {
    margin-top: 67px;
  }
  .raasc1 .rs_title_line {
    background: #FFFFFF;
  }
  .raas_chance_bottom {
    width: 1200px;
    margin: 0 auto;
    padding: 120px 0 140px;
  }
  .raas_chance_item {
    display: flex;
    justify-content: space-between;
  }
  .raas_chance_item + .raas_chance_item {
    margin-top: 140px;
  }
  .rscb_1 .raas_chance_lt img {
    /* width: 662px;
    height: 414px;
    border-radius: 10px;
    box-shadow: 0 4px 20px 0 rgb(0 0 0 / 10%); */
  }
  .raas_chance_rt {
    width: 510px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .rs_chance_title {
    font-family: SourceHanSansCN-Bold !important;
    font-size: 34px;
    color: #222536;
    line-height: 28px;
    font-weight: 700;
    /* margin-top: 48px; */
  }
  .rs_chance_res {
    font-family: SourceHanSansCN-Regular !important;
    font-size: 24px;
    color: #505C68;
    line-height: 34px;
    margin-top:48px;
    display: flex;
  }
  .rs_chance_res::before {
    content: '';
    width: 12px;
    min-width: 12px;
    height: 12px;
    background: #FC5322;
    border-radius: 50%;
    margin: 11px 12px 0 0;
  }
  .rs_chance_res + .rs_chance_res {
    margin-top: 25px;
  }

  .raas_channel .raas_inner {
    background: url("../../static/imgs/baas_bg_channel.jpg") center/cover;
  }
  .raas_channel .raas_chance_bottom{
    padding: 160px 0 200px;
  }
  .raas_channel .raas_chance_lt img {
    width: 610px;
    height: 370px;
  }

  .raas_product .raas_inner {
    background: url("../../static/imgs/baas_bg_product.jpg") center/cover;
  }
  .raas_product .raas_chance_bottom {
    padding: 135px 0 200px;
  }
  .raas_product .raas_chance_lt img {
    width: 610px;
    height: 370px;
  }

  .raas_way .raas_inner {
    background: url("../../static/imgs/baas_bg_way.jpg") center/cover;
  }
  .raas_way .rs_title {
    line-height: 54px;
    margin-top: 28px;
  }
  .raas_way .rs_sub {
    line-height: 46px;
    margin-top: 0;
  }
  .raas_why_bottom {
    width: 1200px;
    margin: 0 auto;
    padding: 174px 0 180px;
    display: flex;
    justify-content: space-between;
  }
  .raas_why_item {
    flex: 1;
    padding: 0 48px;
    text-align: center;
  }
  .raas_why_item + .raas_why_item {
    border-left: 1px solid #F0F0F0;
  }
  .raas_why_item img {
    margin-top: -38px;
    width: 104px;
    height: 104px;
  }
  .rs_why_title {
    font-family: SourceHanSansCN-Medium !important;
    font-size: 22px;
    color: #222536;
    line-height: 26px;
    font-weight: 500;
    margin-top: 30px;
  }
  .rs_why_title_en {
    font-family: Helvetica;
    font-size: 18px;
    color: #8D919B;
    letter-spacing: 0.56px;
    line-height: 20px;
    margin-top: 10px;
  }
  .rs_why_title_line {
    width: 24px;
    height: 2px;
    background: #FC5421;
    border-radius: 2px;
    margin-top: 15px;
  }
  .rs_why_res {
    font-family: SourceHanSansCN-Regular !important;
    font-size: 18px;
    color: #8D919B;
    letter-spacing: 0.56px;
    line-height: 24px;
    font-weight: 400;
    margin-top: 24px;
    text-align: left;
  }

  .raas_break {
    background: #F8F8F8;
    text-align: center;
  }
  .raas_break .raas_inner {
    padding: 140px 0;
  }
  .raas_break .rs_title {
    line-height: 64px;
  }
  .rs_break_bottom {
    display: flex;
    text-align: left;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .rs_break_item {
    width: 573px;
    margin-top: 114px;
    display: flex;
  }
  .rs_break_item img {
    width: 80px;
    min-width: 80px;
    height: 80px;
    margin-right: 32px;
  }
  .rs_break_rt {

  }
  .rs_break_title {
    font-family: SourceHanSansCN-Medium !important;
    font-size: 28px;
    color: #222536;
    letter-spacing: 0.39px;
    font-weight: 500;
  }
  .rs_break_res {
    font-family: SourceHanSansCN-Regular !important;
    font-size: 18px;
    color: #505C68;
    line-height: 24px;
    margin-top: 16px;
  }

  .raas_case {
    text-align: center;
    position: relative;
  }
  .raas_case .rs_bar {
    position: absolute;
    top: 159px;
    cursor: pointer;
  }
  .rs_bar {
    width: 1200px;
    background: #FFEDE7;
    box-shadow: 0px 3px 6px 0px rgba(99,18,0,0.08);
    border-radius: 83px;
    display: flex;
    margin-top: 55px;
    overflow: hidden;
    z-index: 10;
  }
  .rs_bar div {
    font-family: SourceHanSansCN-Bold !important;
    font-size: 28px;
    color: #222536;
    letter-spacing: 0.39px;
    text-align: center;
    font-weight: 700;
    padding: 26px 49px;
    white-space: nowrap;
  }
  .rs_tab {
    padding: 26px 44px !important;
  }
  .rs_tab:last-child {
    flex: 1;
    text-align: left;
  }
  .rs_tab:hover ,.rs_tab_active {
    background-image: linear-gradient(180deg, #FE8B47 0%, #FC5322 100%);
    color: #FFFFFF !important;
  }
  .rs_case_bottom {
    display: none;
    width: 1209px;
    min-height: 768px;
    margin: 116px auto 0;
    padding: 40px 46px;
    background-image: linear-gradient(180deg, #FFFBFA 0%, #FDF5F2 100%);
    z-index: -1;
    text-align: left;
  }
  .rs_case_bottom_active {
    display: block;
  }
  .rsc_title {
    font-family: SourceHanSansCN-Medium !important;
    font-size: 24px;
    color: #222536;
    letter-spacing: 0;
    font-weight: 500;
  }
  .rsc_icon {
    vertical-align: text-bottom;
    margin-right: 10px;
  }
  .rsc_res1, .rsc_res2 {
    font-family: SourceHanSansCN-Bold !important;
    font-size: 20px;
    color: #505C68;
    letter-spacing: 0;
    line-height: 32px;
    font-weight: 400;
    margin-top: 13px;
    font-weight: 700;
  }
  .rsc_img {
    width: 100%;
    margin-top: 40px;
  }
  @media (max-width: 767px) {
    .raas {
      margin-top: 1.6rem;
    }
    .raas_inner {
      width: 100%;
      padding: .75rem 0.48rem .75rem;
    }
    .rs_title {
      font-size: .4rem;
      letter-spacing: 0.0056rem;
      line-height: .56rem;
      font-weight: 700;
      color: #FFFFFF;
    }
    .rs_sub {
      font-size: .4rem;
      letter-spacing: 0.0056rem;
      line-height: .56rem;
      margin-top: 0;
      color: #FFFFFF;
    }
    .rs_res {
      font-size: .28rem;
      line-height: .32rem;
      letter-spacing: .0233rem;
      color: #FFFFFF;
    }
    .rs_button {
      width: 100%;
      height: fit-content;
      text-align: center;
      padding: .2rem .8rem;
      border-radius: .08rem;
      font-size: .3rem;
      line-height: .3rem;
      letter-spacing: .0273rem;
      margin-right: 0 !important;
      box-shadow: 0 .06rem .16rem 0 rgba(251,84,33,0.33);
    }
    .rs_button + .rs_button {
      margin-top: .32rem;
    }
    .rs_button_tran {
      border: .015rem solid rgba(251,84,33,0.85);
      box-shadow: 0 .02rem .16rem 0 rgba(255,144,85,0.26);
    }
    .rs_button_tran:hover {
      background: rgba(251,84,33,0.30);
    }
    .rs_title_line {
      width: .6rem;
      height: .08rem;
      border-radius: .06rem;
      margin-top: .5rem;
    }
    .wt {
      color: #FFFFFF;
    }
    .reverse {
      flex-direction: column;
    }


    .raas_main {
      background: url("../../static/imgs/raas_mbg_main.webp") center/cover, #02021D;
    }
    .noWebp .raas_main {
      background: url("../../static/imgs/raas_mbg_main.png") center/cover, #02021D;
    }
    .raas_main .raas_inner{
      padding: 1rem 0.48rem .9rem;;
    }
    .raas_main_banner {
      flex-direction: column;
      margin-bottom: .56rem;
    }
    .raas_main_blt {

    }
    .raas_main .rs_title {
      font-size: .45rem;
      letter-spacing: .0375rem;
      line-height: .58rem;
      color: #FFFFFF;
      margin-top: 0;
    }
    .raas_main .rs_title div{
      display: none;
    }
    .raas_main .rs_sub {
      font-size: .28rem;
      letter-spacing: .0233rem;
      line-height: .32rem;
      font-weight: 400;
      margin-top: .46rem;
      /* margin-bottom: .74rem; */
      color: #D7DCE9;
    }
    .raas_main_brt {
      margin-left: 0;
      width: 100%;
    }
    .raas_main_brt img {
      width: 100%;
      height: auto;
      margin-top: .56rem;
    }
    .raas_main .rs_button {
      position: relative;
      bottom: 0;
    }

    .raas_chance .raas_inner {
      background: url("../../static/imgs/baas_mbg_chance1.png") center/cover;
      padding: .82rem .48rem;
    }
    .raas_chance .rs_title {
      margin-top: .64rem;
      line-height: .44rem;
    }
    .raas_chance .rs_res {
      margin-top: .27rem;
    }
    .raas_chance .rs_title_line {
      margin-top: .5rem;
    }
    .raas_chance_bottom {
      width: 100%;
      margin: 0 auto;
      padding: .6rem .48rem .75rem;
    }
    .raas_chance_item {
      flex-direction: column-reverse;
    }
    .raas_chance_item + .raas_chance_item {
      margin-top: .6rem;
    }
    .rscb_1 .raas_chance_lt img {
      width: 100%;
      height: auto;
      border-radius: .1rem;
      margin-top: .4rem;
      /* box-shadow: 0 .04rem .2rem 0 rgb(0 0 0 / 10%); */
    }
    .raas_chance_rt {
      width: 100%;
    }
    .rs_chance_title {
      font-size: .34rem;
      line-height: .28rem;
      margin-top: .38rem;
    }
    .rs_chance_res {
      font-size: .24rem;
      line-height: .34rem;
      margin: .4rem 0 0;
    }
    .rs_chance_res::before {
    content: '';
    width: .12rem;
    min-width: .12rem;
    height: .12rem;
    background: #FC5322;
    border-radius: 50%;
    margin: .11rem .12rem 0 0;
  }
  .rs_chance_res + .rs_chance_res {
    margin-top: .21rem;
  }


    .raas_channel .raas_inner {
      background: url("../../static/imgs/baas_mbg_chance.png") center/cover;
    }
    .raas_channel .raas_chance_bottom{
      padding: .6rem .48rem .75rem;
    }
    .raas_channel .raas_chance_lt img {
      width: 100%;
      height: auto;
      margin-top: .4rem;
    }

    .raas_product .raas_inner {
      background: url("../../static/imgs/baas_mbg_chance.png") center/cover;
    }
    .raas_product .raas_chance_bottom {
      padding: .6rem .48rem .75rem;
    }
    .raas_product .rs_chance_title {
      margin-top: 0;
    }
    .raas_product .raas_chance_lt img {
      width: 100%;
      height: auto;
    }

    .raas_way {
      overflow: hidden;
    }
    .raas_way .raas_inner {
      background: url("../../static/imgs/baas_mbg_chance.png") center/cover;
    }
    .raas_way .rs_title {
      line-height: .52rem;
      margin-top: .52rem;
    }
    .raas_way .rs_title div {
      display: none;
    }
    .raas_way .rs_sub {
      line-height: .56rem;
    }
    .raas_way .rs_sub div {
      display: none;
    }
    .raas_why_bottom {
      width: 100%;
      padding: 0 .48rem;
      flex-direction: column;
    }
    .raas_why_item {
      flex: 1;
      padding: .59rem .526rem .8rem;
      box-shadow: 0px 5px 4px 0px rgba(167,167,167,0.06);
    }
    .raas_why_item + .raas_why_item {
      border-left: unset;
    }
    .raas_why_item img {
      margin-top: 0;
      width: 1.68rem;
      height: 1.68rem;
    }
    .rs_why_title {
      font-size: .34rem;
      letter-spacing: 0.0085rem;
      line-height: .44rem;
      font-weight: 700;
      margin-top: .3rem;
    }
    .rs_why_title_en {
      font-size: .28rem;
      letter-spacing: 0;
      line-height: .28rem;
      margin-top: .2rem;
    }
    .rs_why_title_line {
      width: .24rem;
      height: .02rem;
      border-radius: .02rem;
      margin-top: .2rem;
    }
    .rs_why_res {
      opacity: .85;
      font-size: .28rem;
      color: #505C68;
      letter-spacing: 0.0088rem;
      line-height: .36rem;
      margin-top: .3rem;
      text-align: justify;
    }

    .raas_break {
      background: #F8F8F8;
      text-align: center;
    }
    .raas_break .raas_inner {
      padding: .6rem .48rem .75rem;
    }
    .raas_break .rs_title {
      line-height: .56rem;
      color: #222536;
      padding: 0 .3rem;
    }
    .raas_break .rs_title div {
      display: none;
    }
    .rs_break_bottom {
      margin-top: .55rem;
    }
    .rs_break_item {
      width: 100%;
      margin-top: 0;
      align-items: center;
    }
    .rs_break_item + .rs_break_item {
      margin-top: 0.4rem;
    }
    .rs_break_item img {
      width: .88rem;
      min-width: .88rem;
      height: .88rem;
      margin-right: .12rem;
    }
    .rs_break_rt {
      width: 100%;
    }
    .rs_break_title {
      font-size: .34rem;
      letter-spacing: 0.0047rem;
    }
    .rs_break_res {
      font-size: .24rem;
      line-height: .24rem;
      margin-top: .2rem;
    }

    .raas_case .rs_title {
      color: #222536;
    }
    .raas_case .rs_bar {
      top: 1.75rem;
    }
    .rs_bar {
      width: calc(100% - .96rem);
      box-shadow: 0 .03rem .06rem 0px rgba(99,18,0,0.08);
      border-radius: .83rem;
      margin-top: .56rem;
      overflow-x: auto;
    }
    .rs_bar div {
      font-size: .16rem;
      line-height: .16rem;
      letter-spacing: 0.0022rem;
    }
    .rs_tab {
      padding: .25rem .155rem !important;
    }
    .rs_tab:first-child {
      padding-left: .35rem !important;
    }
    .rs_tab:last-child {
      padding-right: .45rem !important;
    }
    .rs_case_bottom {
      width: 100%;
      min-height: fit-content;
      margin: .73rem auto 0;
      padding: .62rem .22rem .5rem;
      background: #FDF5F2;;
      overflow: hidden;
    }
    .rsc_title {
      font-size: .24rem;
    }
    .rsc_icon {
      vertical-align: text-bottom;
      max-width: .32rem;
      max-height: .32rem;
      margin-right: .1rem;
      margin-left: -.07rem;
    }
    .rsc_res1, .rsc_res2 {
      font-size: .2rem;
      line-height: .32rem;
      margin-top: .08rem;
    }
    .rsc_img {
      width: calc(100% + .54rem);
      margin: .35rem -.27rem .24rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/solutionBaas.vue